import type { JSX } from 'react'
import { RoofRack } from './RoofRack'
import { illustrationColors, seasonColors } from './shared'

const { trim } = illustrationColors
const { paper, paperEdge, white, pink, orange, purple, coolBox, ochre, red, jute, juteShade } = seasonColors

export function EasterRoofLoad(): JSX.Element {
  return (
    <g>
      <RoofRack />
      <path d="M157 95C159 74 203 74 205 95" fill="none" stroke={juteShade} strokeWidth="2.8" />
      <path d="M155 96C154 89 157 85 160 85C164 85 167 90 166 96Z" fill={pink} />
      <path d="M167 96C166 88 169 84 173 84C177 84 180 89 179 96Z" fill={illustrationColors.body} />
      <path d="M180 96C179 89 182 85 186 85C190 85 193 90 192 96Z" fill={coolBox} />
      <path d="M193 96C192 88 195 84 199 84C203 84 206 90 205 96Z" fill={purple} />
      <path d="M155 92H166M168 91H179M181 92H192M194 91H205" fill="none" stroke={white} strokeWidth="1.7" />
      <path d="M151 96H211L206 111H156Z" fill={jute} />
      <path d="M153 101H209M155 106H207" fill="none" stroke={juteShade} strokeWidth="1.2" />
      <path d="M151 95H211" fill="none" stroke={juteShade} strokeWidth="3.4" strokeLinecap="round" />
    </g>
  )
}

export function createEasterScenery(): string {
  return `<g opacity=".88"><defs><g id="e">
  <g stroke="${trim}" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round">
    <path d="M13 245C12 238 14 231 18 230C22 231 24 238 23 245Z" fill="${pink}"/>
    <path d="M28 245C27 239 29 233 33 232C37 233 39 239 38 245Z" fill="${coolBox}"/>
    <path d="M13 240H23M28 241H38" fill="none" stroke="${paper}" stroke-width="2"/>
    <ellipse cx="47" cy="237" rx="9" ry="7" fill="${ochre}"/>
    <circle cx="47" cy="227" r="6" fill="${ochre}"/>
    <ellipse cx="51" cy="237" rx="3" ry="4" fill="${orange}"/>
    <path d="M41 222C40 218 43 219 44 222M46 221C47 217 50 219 49 222" fill="${red}"/>
    <path d="M52 226L58 228L52 230Z" fill="${orange}"/>
    <circle cx="45" cy="226" r=".8" fill="${trim}"/>
    <path d="M44 243L43 246M50 243L51 246" fill="none"/>
    <g fill="${white}" stroke="${paperEdge}" stroke-width="1.1">
      <circle cx="78" cy="239" r="4"/>
      <path d="M88 245C78 245 75 239 78 231C80 225 85 222 90 224C96 226 97 236 94 242C93 244 91 245 88 245Z"/>
      <path d="M88 214C86 209 85 199 88 197C91 196 93 207 92 214Z"/>
      <path d="M94 214C94 207 97 197 100 198C103 199 99 210 97 216Z"/>
      <path d="M86 215C90 211 97 212 100 216C101 218 101 220 103 221C104 224 99 227 95 228C88 229 84 225 85 220C85 218 85 217 86 215Z"/>
      <ellipse cx="87" cy="245" rx="5" ry="2.2"/>
      <ellipse cx="96" cy="245" rx="3.5" ry="2"/>
    </g>
    <path d="M89 210C88 205 88 200 89 200C91 202 91 207 91 211ZM96 211C96 206 98 201 99 201C100 202 98 208 97 212Z" fill="${pink}" stroke="none"/>
    <circle cx="97" cy="218" r=".8" fill="${trim}" stroke="none"/>
    <ellipse cx="102" cy="221" rx="1.2" ry=".8" fill="${pink}" stroke="none"/>
    <path d="M106 245C105 239 107 233 111 232C115 233 117 239 116 245Z" fill="${purple}"/>
    <path d="M106 240H116" fill="none" stroke="${paper}" stroke-width="2"/>
  </g>
</g></defs><use href="#e"/><use href="#e" x="200"/><use href="#e" x="400"/></g>`
}
